import Actions from "./Actions";
import Name from "./Name";
import NoCipher from "./NoCipher";
import DetailList from "./DetailList";
import HistoryActions from "./HistoryActions";

const cipherComponents = {
  Actions,
  Name,
  NoCipher,
  DetailList,
  HistoryActions
}

export default cipherComponents